import { c as _c } from "react/compiler-runtime";
import { useLocale } from 'next-intl';
import { ValueChangeArrow } from '@/components/ui/value-change-arrow';
import { formatPercentValue } from '@/lib/format/format-number';
import { cn } from '@/lib/ui/utils';

/**
 * Signed basis-point value rendered as an arrow + percentage, tinted by sign.
 * Neutral grey on a zero move or an unavailable value.
 * Shared by the winner-page token stats and the graduated `TokenCta` card.
 */
export function SignedBps(t0) {
  const $ = _c(16);
  const {
    bps
  } = t0;
  const locale = useLocale();
  const value = Number(bps ?? 0) / 100;
  let t1;
  if ($[0] !== value) {
    t1 = Number.isFinite(value) ? value : 0;
    $[0] = value;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const pct = t1;
  let isZero;
  let t2;
  if ($[2] !== locale || $[3] !== pct) {
    const abs = Math.abs(pct);
    isZero = Math.round(abs * 10) === 0;
    t2 = formatPercentValue(abs, locale, isZero ? 1 : 0);
    $[2] = locale;
    $[3] = pct;
    $[4] = isZero;
    $[5] = t2;
  } else {
    isZero = $[4];
    t2 = $[5];
  }
  const label = `${t2}%`;
  if (isZero) {
    let t3;
    if ($[6] !== label) {
      t3 = <span className="text-foreground-tertiary">{label}</span>;
      $[6] = label;
      $[7] = t3;
    } else {
      t3 = $[7];
    }
    return t3;
  }
  const isUp = pct > 0;
  const t3 = isUp ? "text-data-profit" : "text-data-loss";
  let t4;
  if ($[8] !== t3) {
    t4 = cn("inline-flex items-center gap-1", t3);
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const t5 = isUp ? "up" : "down";
  let t6;
  if ($[10] !== t5) {
    t6 = <ValueChangeArrow direction={t5} className="size-3" />;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== label || $[13] !== t4 || $[14] !== t6) {
    t7 = <span className={t4}>{t6}{label}</span>;
    $[12] = label;
    $[13] = t4;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
}